// extracted by mini-css-extract-plugin
module.exports = {"typeBonus":"styles_typeBonus__Kn2jm","bonusesContainer":"styles_bonusesContainer__BnTb2","bonusesQueue":"styles_bonusesQueue__eNR74"};